"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PinIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M4.892 0c-.515 0-.764.637-.388.993l1.095.932-.948 5.751L3.14 9.38c-.32.371-.06.951.428.951h3.577v3.8a.58.58 0 00.037.201l.55 1.482a.282.282 0 00.53 0l.55-1.482a.58.58 0 00.037-.202v-3.799h3.581c.487 0 .748-.578.429-.95l-1.516-1.713-.947-5.746 1.09-.928C11.864.638 11.615 0 11.1 0H4.892z"
  })))
});
PinIcon.displayName = 'PinIcon';
var _default = exports.default = PinIcon;